import { ControlType, FetchStatus } from "../../../../base/types";
import { CookieVerificationProperties, useCookieVerification } from "./useCookieVerification";
import { ErrorMessage, Spinner } from "../../../../widgets";

import { CookieVerification } from "./CookieVerification";
import { DraftCookieVerification } from "./DraftCookieVerification";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { Registry } from "../../../../base/register";

export const CookieVerificationComponent: FC<IControlAttributes> = ({
    children, props
}) => {
    const { status, properties, error } = useCookieVerification(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) {
        return <></>
    }

    return <CookieVerification {...properties}>
        {children}
    </CookieVerification>
}

Registry.addControl({
    id: "1c925c9b-6e11-4887-9e1f-92b7ddae2849",
    name: "Cookie Verification",
    type: ControlType.CookieVerification,
    properties: CookieVerificationProperties,
    component: CookieVerificationComponent,
    draftComponent: DraftCookieVerification
})
